import { render, staticRenderFns } from "./CodigoServicoG4.vue?vue&type=template&id=9802bbc2"
import script from "./CodigoServicoG4.vue?vue&type=script&lang=js"
export * from "./CodigoServicoG4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports